export class Image {
  public WebContentID: number;
  public RelativePath: string;
  public AbsolutePath: string;
  public Title: string;
  public constructor() {
    this.WebContentID = 0;
    this.RelativePath = '';
    this.AbsolutePath = '';
    this.Title = '';
  }
}
